/**
 * 是否为 Capacitor iOS 原生包（无 @capacitor/camera 等重依赖，供 App.js 等广泛使用）
 */
export function isCapacitorIosNative() {
  if (typeof window === 'undefined') return false;
  const C = window.Capacitor;
  if (!C || typeof C.isNativePlatform !== 'function' || typeof C.getPlatform !== 'function') {
    return false;
  }
  try {
    return C.isNativePlatform() === true && C.getPlatform() === 'ios';
  } catch (e) {
    return false;
  }
}
